export const QUERY_PARAM_PAGE = 'page'

export const PRICE_PAGE_GOAL = {
  VISIT: 'lpu_services__visit_page',
  SEARCH: 'lpu_services__use_search',
  CLICK_PRICE: 'lpu_services__click_service_price_button',
} as const
